<!-- 
      <div class="navbar-minimize">
        <button mat-raised-button (click)="minimizeSidebar()" class="btn btn-just-icon btn-white btn-fab btn-round">
          <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
          <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
        </button>
      </div>
--->


<div>
  <nav class="navbar navbar-main navbar-expand-lg"> 

    <ul class="navbar-nav mr-auto" *ngFor="let link of linkInfos.routeInfos">
      <li *ngIf="link.type === 'dropdown'" class="nav-item dropdown ">
        <a class="nav-link dropdown-toggle  custom-navbar-text" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {{link.title}}
        </a>
        <div  class="dropdown-menu " aria-labelledby="navbarDropdown">
          <a *ngFor="let dropdownItem of link.children" class="dropdown-item" [routerLink]="[dropdownItem.path]">
            <span class="finance-dropdown-icon">
              <img [src]='dropdownItem.iconName' alt="">
            </span>
            <span class="dropdown-title" (click)="dropdownItem.path === '/izrada' && warning()">{{dropdownItem.title}}</span>
          </a>
        </div>
      </li>
    
      <li  *ngIf="link.type !== 'dropdown'" routerLinkActive="active" class="nav-item">
        <a [routerLink]="[link.path]" class="nav-link">
          <h4 class="navbar-title-main">{{ link.title }}</h4>
        </a>
      </li>
    </ul>
  </nav>
</div>
  
  
  